export default "__VITE_ASSET__Bdu1xxw5__"